import { Mic, Search } from "lucide-react";
import { useT } from "@/i18n";

const hasVoice = typeof window !== "undefined" && !!(window.SpeechRecognition || window.webkitSpeechRecognition);
const openSearch = (detail) => window.dispatchEvent(new CustomEvent("open-search", { detail }));

export const HeroSearch = () => {
  const t = useT();
  return (
    <div className="mt-8 flex w-full max-w-xl items-center gap-2 rounded-full border border-white/20 bg-[#1B1816]/80 p-1.5 pl-5 backdrop-blur-md transition-colors duration-300 focus-within:border-[#D98A52] hover:border-[#D98A52]/70" data-testid="hero-search">
      <Search className="h-5 w-5 shrink-0 text-[#D98A52]" />
      <button onClick={() => openSearch({})} className="min-w-0 flex-1 truncate py-3 text-left text-base text-[#CFC8BC]" data-testid="hero-search-open">
        {t("hero.search", "Cerca: travi curve, X-LAM, casa in legno…")}
      </button>
      {hasVoice && (
        <button onClick={() => openSearch({ voice: true })} className="grid h-12 w-12 shrink-0 place-items-center rounded-full bg-[#C26D38] text-[#FFF8F0] transition-transform duration-200 hover:scale-105" data-testid="hero-search-mic" aria-label={t("search.mic", "Cerca parlando")}>
          <Mic className="h-5 w-5" />
        </button>
      )}
    </div>
  );
};
